import { Directive, ElementRef, inject, input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

/**
 * lvrInput directive applies LVR input styling to mat-form-field.
 * Usage: <mat-form-field lvrInput>...</mat-form-field>
 */
@Directive({
	selector: '[lvrInput]',
	standalone: true,
})
export class LvrInputDirective implements OnChanges {
	public readonly lvrShowWarning = input<boolean>(false);
	public readonly lvrError = input<boolean>(false);

	private readonly el = inject(ElementRef);
	private readonly renderer = inject(Renderer2);

	public ngOnChanges(_changes: SimpleChanges): void {
		this.updateStateClasses();
	}

	private updateStateClasses(): void {
		const matFormField = this.el.nativeElement;
		const wrapper = matFormField.querySelector('.mat-mdc-text-field-wrapper');
		if (!wrapper) return;
		if (this.lvrError()) {
			this.renderer.addClass(matFormField, 'lvr-error');
		} else if (this.lvrShowWarning()) {
			this.renderer.addClass(matFormField, 'lvr-warning');
		} else {
			this.renderer.removeClass(matFormField, 'lvr-error');
			this.renderer.removeClass(matFormField, 'lvr-warning');
		}
	}
}
